import templateUrl from 'servicestack/auto-query/auto-query-refinements-panel.htm'
import BasicController from 'servicestack/basic.controller'

const AutoQueryRefinementsPanelComponent = {
    bindings: {
        panelType: '@',
        collapsed: '@',
        maxPanelHeight: '@',
        title: '@',
        query: '<'
    },
    controller: BasicController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default AutoQueryRefinementsPanelComponent;
